var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('login-container',{scopedSlots:_vm._u([{key:"content",fn:function(){return [(_vm.loading)?[_vm._v(" "+_vm._s(_vm.$t('loading'))+" ")]:[_c('user-list',{attrs:{"fusionAuth":true,"userToken":_vm.userToken}})]]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }